<div class="content-data" [class.centralize]="isCentralized" [ngStyle]="styleObject()">
    <ng-content></ng-content>
</div>